module.exports = __webpack_public_path__ + "static/media/mergeLeft.f3e13cc4.svg";